import React, { ReactElement, useContext } from 'react';

import GroupedList from 'octa-front-sdk/dist/components/GroupedList';
import FbPixel from '../../services/FbPixel';

import { useLoyalty } from '../../hooks/Loyalty';

import { Product } from '../../types/Product';
import { Prize } from '../../types/Prize';

import DishesStyles from './styles';

import DishCard from './DishCard';

interface IProps {
  dishes: Product[];
  openWizard: () => unknown;
  setCurrentDish: React.Dispatch<
    React.SetStateAction<Partial<Product> | undefined>
  >;
}

const Dishes: React.FC<IProps> = (props): ReactElement => {
  const { dishes, openWizard, setCurrentDish } = props;
  const { loyaltyProgram, memberPoints } = useLoyalty();

  return (
    <DishesStyles.Container>
      <GroupedList
        values={dishes}
        groupBy="category"
        render={(dish): ReactElement => {
          const { id } = dish;

          let prizeIndex;
          let hasPoints = false;

          if (!!loyaltyProgram && !!memberPoints) {
            prizeIndex = loyaltyProgram.prizes.findIndex(
              (prize: Prize): boolean => parseInt(prize.productId) === id,
            );

            if (prizeIndex > -1) {
              hasPoints =
                memberPoints.validPoints >=
                loyaltyProgram.prizes[prizeIndex].priceInPoints;
            }
          }

          return (
            <DishCard
              onClickCard={(): void => {
                FbPixel.trackEvent('ViewContent', {
                  content_ids: [dish.id],
                  content_type: 'product',
                  value: dish.displayPrice.toFixed(2),
                  currency: 'BRL',
                });

                setCurrentDish({ ...dish });

                openWizard();
              }}
              dish={dish}
              hasPoints={hasPoints}
            />
          );
        }}
      />
    </DishesStyles.Container>
  );
};

export default Dishes;
